import { ArtistPortalDimensionTotal } from 'fym-shared/src/smartlinks/artistPortals';
import { changePctOf } from './streamingFormat';

export type DimensionMetric = 'streams' | 'downloads';

export interface DimensionRowModel {
  value: string;
  rank: number;
  number: number | null;
  /** 0 to 1 of the sum of all values. Null when the sum is 0. */
  share: number | null;
  changePct: number | null;
}

/**
 * The ranked rows of a store or country list (design c1, c2), largest first, for streams or for
 * downloads. The share is of the sum of all values of the list.
 */
export function buildDimensionRows(totals: ArtistPortalDimensionTotal[], metric: DimensionMetric): DimensionRowModel[] {
  const numberOf = (total: ArtistPortalDimensionTotal) => (metric === 'streams' ? total.streams : total.downloads);
  const previousOf = (total: ArtistPortalDimensionTotal) =>
    metric === 'streams' ? total.previousStreams : total.previousDownloads;
  const sum = totals.reduce((acc, total) => acc + (numberOf(total) ?? 0), 0);
  return [...totals]
    .filter((total) => numberOf(total) !== null)
    .sort((left, right) => (numberOf(right) ?? 0) - (numberOf(left) ?? 0))
    .map((total, index) => {
      const number = numberOf(total);
      return {
        value: total.value,
        rank: index + 1,
        number,
        share: sum > 0 && number !== null ? number / sum : null,
        changePct: changePctOf(number, previousOf(total)),
      };
    });
}
